import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
function TermsConditions() {
     const [pageTitle,setPageTitle] = useState('About Us');
                const [pageContent,setPageContent] = useState('');
            useEffect(() => {
                    getData()
                }, []);
                const getData = async () => {
                    try {
                        const response = await fetch('https://api.kahaaniplus.com/api/v1/page/terms-conditions');
                        const data = await response.json();
                        setPageTitle(data.data.page_title);
                        setPageContent(data.data.page_content);
                        console.log(data);
                    } catch (error) {
                        console.error('Error fetching data:', error);
                    }
                };
    return (
        <Container className='mt-5'>
            <h1 className='text-center'>{pageTitle}</h1>
            <p className='my-para' dangerouslySetInnerHTML={{ __html: pageContent }}>
             {/*    <ul>
                    <li>
                        1. Introduction
                        These Terms and Conditions ("Terms") govern your access to and use of kahaaniplus website, services, and applications (collectively, the "Service"). By accessing or using the Service, you agree to be bound by these Terms and all applicable laws and regulations.
                    </li>
                    <li>
                        2. Use License
                        <ul>
                            <li>
                                a. Subject to your compliance with these Terms, TIARA DIGITAL SERVICES PRIVATE LIMITED grants you a non-exclusive, non-transferable, revocable license to access and use the Service for your personal, non-commercial use only.
                            </li>
                            <li>
                                b. This license does not include any resale or commercial use of the Service or its contents; any collection and use of any product listings, descriptions, or prices; any derivative use of the Service or its contents; any downloading or copying of account information for the benefit of another merchant; or any use of data mining, robots, or similar data gathering and extraction tools.
                            </li>
                        </ul>
                    </li>
                    <li>
                        3. Intellectual Property Rights
                        <ul>
                            <li>
                                a. All content included on the Service, such as text, graphics, logos, images, as well as the compilation thereof, and any software used on the Service, is the property of TIARA DIGITAL SERVICES PRIVATE LIMITED or its content suppliers and protected by copyright and other laws that protect intellectual property and proprietary rights.
                            </li>
                            <li>
                                b. You agree to observe and abide by all copyright and other proprietary notices, legends, or other restrictions contained in any such content and will not make any changes thereto.
                            </li>
                        </ul>
                    </li>
                    <li>
                        4. User Conduct
                        You agree not to use the Service in a manner that:
                        <ul>
                            <li>
                                a. Is illegal, or promotes or encourages illegal activity;
                            </li>
                            <li>
                                b. Infringes on the intellectual property rights of this website or others;
                            </li>
                            <li>
                                c. Is harmful, fraudulent, deceptive, threatening, abusive, harassing, tortious, defamatory, vulgar, obscene, libelous, or otherwise objectionable.
                            </li>
                        </ul>
                    </li>
                    <li>
                        5. Third-Party Content and Services
                        <ul>
                            <li>
                                a. The Service may provide links to third-party websites or services that are not owned or controlled by this website. www.kahaaniplus.in has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third-party websites or services.
                            </li>
                            <li>
                                b. You further acknowledge and agree that TIARA DIGITAL SERVICES PRIVATE LIMITED shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods, or services available on or through any such websites or services.
                            </li>
                        </ul>
                    </li>
                    <li>
                        6. Disclaimer of Warranties
                        The Service is provided on an "AS IS" and "AS AVAILABLE" basis. TIARA DIGITAL SERVICES PRIVATE LIMITEDmakes no representations or warranties of any kind, express or implied, as to the operation of the Service or the information, content, materials, or products included on the Service.
                    </li>
                    <li>
                        7. Limitation of Liability
                        In no event shall TIARA DIGITAL SERVICES PRIVATE LIMITED, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from
                        <ul>
                            <li>
                                (i) your access to or use of or inability to access or use the Service;
                            </li>
                            <li>
                                (ii) any conduct or content of any third party on the Service;
                            </li>
                            <li>
                                (iii) any content obtained from the Service; and
                            </li>
                            <li>
                                (iv) unauthorized access, use or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage.
                            </li>
                        </ul>
                    </li>
                    <li>
                        8. Indemnification
                        You agree to indemnify, defend and hold harmless Kahaani plus, its principals, officers, directors, representatives, employees, contractors, licensors, licensees, suppliers, and agents, from and against any claims, losses, damages, obligations, costs, actions, or demands.
                    </li>
                    <li>
                        9. Changes to Terms
                        Kahaani plus reserves the right, at its sole discretion, to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
                    </li>
                    <li>
                        10. Governing Law
                        These Terms shall be governed and construed in accordance with the laws of INDIA, without regard to its conflict of law provisions.
                    </li>
                    <li>
                        11. Contact Information
                        If you have any questions about these Terms, please contact us at contactus@tiaradigital.in
                    </li>
                    <li>
                        12. Acknowledgment
                        By using the Service, you acknowledge that you have read these Terms and agree to be bound by them.
                    </li>
                    <li>
                        13. Termination
                        www.kahaaniplus.in may terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
                    </li>
                    <li>
                        14. Entire Agreement
                        These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have had between us regarding the Service.
                    </li>
                </ul>
 */}
            </p>
        </Container>
    )
}
export default TermsConditions